export const companyStatusOptions = [
  { value: "created", label: "Déjà créée" },
  { value: "registering", label: "En cours d'immatriculation" },
  { value: "planning", label: "En projet" },
];

export const legalStatusOptions = [
  { value: "ei_regime_reel", label: "EI - Entreprise Individuelle (Régime Réel)" },
  { value: "eurl", label: "EURL - Entreprise Unipersonnelle à Responsabilité Limitée" },
  {
    value: "sarl",
    label: "SARL - Société à Responsabilité Limitée",
  },
  { value: "sas", label: "SAS - Société par Actions Simplifiée" },
  { value: "sasu", label: "SASU - Société par Actions Simplifiée Unipersonnelle" },
  { value: "sci", label: "SCI - Société Civile Immobilière" },
  { value: "auto_entrepreneur", label: "Auto-entrepreneur" },
];

export const hasAccountantOptions = [
  {
    value: "true",
    label: "Yes",
  },
  {
    value: "false",
    label: "No",
  },
];

export const accountantProposesOptions = [
  {
    value: "full_accounting",
    label: "Tenue complète de la comptabilité",
  },
  {
    value: "annual_accounts",
    label: "The establishment of annual accounts",
  },
  {
    value: "tax_declarations",
    label: "The scales declared",
  },
  {
    value: "consulting",
    label: "Advice (legal, tax, social)",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const accountantTypesOptions = [
  {
    value: "traditional",
    label: "A traditional accountant",
  },
  {
    value: "online",
    label: "An online accountant",
  },
];

export const serviceTypeOptions = [
  {
    value: "administrations",
    label: "Administrations and communities",
  },
  {
    value: "agriculture",
    label: "Agriculture",
  },
  {
    value: "association",
    label: "Association",
  },
  {
    value: "cafe_hotel",
    label: "Café / Hotel / Restaurant",
  },
  {
    value: "retail_food",
    label: "Retail Food Trade",
  },
  {
    value: "retail_nonfood",
    label: "Retail Non-Food Trade",
  },
  {
    value: "wholesale",
    label: "Wholesale Trade",
  },
  {
    value: "auto_repair",
    label: "Vehicle Trade and Repair",
  },
  {
    value: "construction",
    label: "Construction / Civil Engineering",
  },
  {
    value: "real_estate",
    label: "Real Estate",
  },
  {
    value: "industry_logistics",
    label: "Industry, Transport and Logistics",
  },
  {
    value: "health",
    label: "Healthcare Professionals",
  },
  {
    value: "business_services",
    label: "Business Services",
  },
  {
    value: "personal_services",
    label: "Personal Services",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const revenueOptions = [
  {
    value: "less_50k",
    label: "Less than 50 000",
  },
  {
    value: "less_250k",
    label: "Less than 250 000",
  },
  {
    value: "less_500k",
    label: "Less than 500 000",
  },
  {
    value: "more_500k",
    label: "More than 500 000",
  },
];

export const numberOfEmployeesOptions = [
  {
    value: "less_5",
    label: "0 - 5",
  },
  {
    value: "less_10",
    label: "5 - 10",
  },
  {
    value: "less_20",
    label: "10 - 20",
  },
  {
    value: "more_20",
    label: " +20",
  },
];
